<template>
  <div class="party-work">
    <div class="box">
      <div class="title">
        <img src="@/assets/index/joinParty/dp-lc1-icon3.png" alt />
        党组织工作
      </div>
      <div class="content">
        <div class="content-template" v-for="data in datas[name]" :key="data.name">
          <span v-text="data.name+': '"></span>
          <span v-text="data.content"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [
        [
          {
            name: "★条件",
            content:
              "年满18岁的中国公民;承认党的纲领和章程;愿意参加党的一个组织并在其中积极工作;愿意执行党的决议;按期交纳党费"
          },
          {
            name: "★要求",
            content:
              "年满18岁的中国公民;承认党的纲领和章程;愿意参加党的一个组织并在其中积极工作;愿意执行党的决议;按期交纳党费"
          },
          {
            name: "★申请",
            content:
              "年满18岁的中国公民;承认党的纲领和章程;愿意参加党的一个组织并在其中积极工作;愿意执行党的决议;按期交纳党费"
          }
        ],
        [
          {
            name: "★时间",
            content: "收到入党申请书后1个月内。"
          },
          {
            name: "★主体:",
            content: "党支部书记、副书记或组织委员。"
          },
          {
            name: "★内容",
            content: "了解入党申请人基本情况;介绍入党条件和程序;加强教育引导。"
          }
        ],
        [
          {
            name: "★范围",
            content: "已递交入党申请书且党组织已派人谈话的人员。"
          },
          {
            name: "★方式",
            content: "党员推荐、群团组织推优等方式。"
          }
        ],
        [
          {
            name: "★材料",
            content: "入党申请人基本情况;推荐和推优情况;支部委员会意见等。"
          },
          {
            name: "★要求:",
            content: "了解入党积极分子是否具备条件;手续是否齐全。"
          }
        ],
        [
          {
            name: "★数量",
            content: "1-2名正式党员。"
          },
          {
            name: "★任务",
            content:
              "向入党积极分子介绍党的基本知识;了 解入党积极分子的政治觉悟、道德品质、现实表现和家庭情况等，做好培养教育工作，引导入党积极分子端正入党动机;及时向党支部汇报入党积极分子情况;向党支部提出能否将入党积极分子列为发展对象的意见。"
          }
        ],
        //6
        [
          {
            name: "★方法",
            content:
              "吸收入党积极分子听党课、参加党内有关活动、分配一定的社会工作、集中培训等。"
          },
          {
            name: "★目的",
            content:
              "使入党积极分子懂得党的性质、纲领、宗旨、组织原则、纪律、党员的义务和权利，帮助端正入党动机，确立为共产主义事业奋斗终身的信念。"
          },
          {
            name: "★要求",
            content:
              "党支部每半年对入党积极分子进行1次考察;基层党委每年对入党积极分子队伍状况作1次分析。"
          },
          {
            name: "★注意",
            content:
              "入党积极分子工作、学习单位(居住地)发生变动，应及时报告原单位(居住地)党组织;原单位(居住地)党组织应及时转交材料;接收单位党组织认真审查材料、做好接续培养，培养教育时间可连续计算。"
          }
        ],
        //7
        [
          {
            name: "★条件",
            content: "经过1年以上培养教育和考察;基本具备党员条件。"
          },
          {
            name: "★要求",
            content: "向听取党小组、培养联系人、党员和群众意见。"
          },
          {
            name: "★确定",
            content: "支部委员会讨论同意，确定发展对象人选。"
          }
        ],
        //8
        [
          {
            name: "★要求",
            content: "认真审查；提出意见"
          },
          {
            name: "★注意",
            content: "同意后列为发展对象"
          }
        ],
        //9
        [
          {
            name: "★数量",
            content: "2名正式党员。"
          },
          {
            name: "★方式",
            content: "一般由培养联系人担任，也可由党组织指定。"
          },
          {
            name: "★要求",
            content: "入党介绍人认真完成培养、教育任务。"
          },
          {
            name: "★注意",
            content: "受留党察看处分、尚未恢复党员权利的党员，不能作入党介绍人"
          }
        ],
        //10
        [
          {
            name: "★内容",
            content:
              "对党的理论和路线、方针、政策的态度;政治历史和在重大政治斗争中的表现;遵纪守法和遵守社会公德情况;直系亲属和本人关系密切的主要社会关系的政治情况。"
          },
          {
            name: "★方法",
            content:
              "同本人谈话、查阅档案资料、找有关单位和人员了解情况以及必要的函调和外调。对流动人员中的发展对象还应当征求户籍所在地和居住地基层党组织的意见。"
          },
          {
            name: "★要求",
            content:
              "政治审查必须严肃认真、实事求是，注重本人的一贯表现。审查情况形成结论性材料。"
          },
          {
            name: "★注意",
            content: "未经政治审查或政治审查不合格的，不能发展入党。"
          }
        ],
        //11
        [
          {
            name: "★主体",
            content: "基层党委或县级党委组织部门"
          },
          {
            name: "★时间",
            content: "不少于3天或不少于24学时"
          },
          {
            name: "★注意",
            content: "未经培训的，除个别特殊情况外，不能发展入党"
          }
        ],
        //12
        [
          {
            name: "★要求",
            content:
              "征求党员和群众的意见;对发展对象进行严格审查;集体讨论是否合格。"
          }
        ],
        //13
        [
          {
            name: "★方式",
            content:
              "审查发展对象条件、培养教育情况等;根据需要，听取执纪执法等部门意见。"
          },
          {
            name: "★要求",
            content:
              "审查结果书面通知党支部;向审查合格的发展对象发放《中国共产党入党志愿书》。"
          },
          {
            name: "★注意",
            content:
              "发展对象未来3个月内将离开工作、学习单位的，一般不办理接收预备党员手续。"
          }
        ],
        //14
        [
          {
            name: "★要求",
            content: "在入党介绍人的指导下，由本人按照要求如实填写"
          }
        ],
        //15
        [
          {
            name: "★要求",
            content:
              "(1)发展对象汇报个人情况; (2) 入党介绍人介绍发展对象有关情况、表明意见; (3) 支部委员会报告审查情况;(4) 与会党员充分讨论、投票表决。"
          },
          {
            name: "★注意",
            content:
              "有表决权的到会人数必须超过应到会有表决权人数的半数，才能开会;赞成人数超过应到会有表决权的正式党员的半数，方可通过。讨论两个以上发展对象入党时，要逐个讨论和表决。"
          }
        ],
        //16
        [
          {
            name: "★时间",
            content: "党委审批前。"
          },
          {
            name: "★人员",
            content: "党委委员或组织员。"
          },
          {
            name: "★目的",
            content: "作进一步了解，并帮助发展对象提高对党的认识。"
          },
          {
            name: "★要求",
            content:
              "谈话人应当将谈话情况和自已发展对象能否入党的意见，如实填写在《中国共产党入党志愿书》上，并向党委汇报。"
          }
        ],
        //17
        [
          {
            name: "★内容",
            content: "是否具备党员条件、入党手续是否完备。"
          },
          {
            name: "★要求",
            content: "集体讨论和表决。两个以上发展对象应当逐个审议和表决。"
          },
          {
            name: "★时间",
            content: "3个月内，特殊情况不超过6个月。"
          },
          {
            name: "★注意",
            content:
              "党总支、乡镇(街道)所属的基层党委以及党组不能审批预备党员。除另有规定外，临时党组织不能接收、审批预备党员。"
          }
        ],
        //18
        [
          {
            name: "★目的",
            content: "掌握预备党员结构、分布、质量等情况;发现问题，及时解决。"
          }
        ],
        //19
        [
          {
            name: "★要求",
            content: "及时编入；继续进行教育和考察。"
          }
        ],
        //20
        [
          {
            name: "★组织",
            content: "及时编入；继续进行教育和考察。"
          },
          {
            name: "★程序",
            content:
              "(1) 奏《国际歌》; (2) 党组织负贵同志致辞; (3) 预备党员宣誓;(4)参加宣誓的预备党员代表发言; (5) 党组织负责同志讲话、提出要求。"
          },
          {
            name: "★要求",
            content: "在正式场合举行;严肃认真;庄重简朴;严密紧凑。"
          }
        ],
        //21
        [
          {
            name: "★方式",
            content:
              "参加党的组织生活、听本人汇报、个别谈心、集中培训、实践锻炼等。"
          },
          {
            name: "★时间",
            content: "预备期为1年。"
          }
        ],
        //22
        [
          {
            name: "★要求",
            content: "预备期满，书面提出申请。"
          }
        ],
        //23
        [
          {
            name: "★准备",
            content:
              "党小组提出意见;党支部征求党员和群众的意见;支部委员会审查。"
          },
          {
            name: "★程序",
            content: "参照接收预备党员的程序。"
          },
          {
            name: "★结果",
            content:
              "认真履行党员义务、具备党员条件的，按期转为正式党员;需要继续考察和教育的，可以延长1次预备期，延长时间不能少于半年，最长不超过1年;不履行党员义务、不具备党员条件的，取消预备党员资格。"
          }
        ],
        //24
        [
          {
            name: "★时间",
            content: "3个月内。"
          },
          {
            name: "★要求",
            content:
              "审批结果及时通知党支部。党支部书记应当同本人谈话，并将审批结果在党员大会上宣布。"
          },
          {
            name: "★结果",
            content: "党员的党龄从预备期满转为正式党员之日算起。"
          }
        ],
        //25
        [
          {
            name: "★内容",
            content:
              "《 中国共产党入党志愿书》、入党申请书、政治审查材料、转正申请书、培养教育考察材料。"
          },
          {
            name: "★要求",
            content:
              "有人事档案的，存入本人人事档案;无人事档案的，建立党员档案，由所在党委或县级党委组织部门保存。"
          }
        ]
      ]
    };
  },
  mounted() {
    // console.log(this.datas[this.name].msgs);
  },
  name: "partyWork",
  props: {
    name: Number
  }
};
</script>
<style lang='scss' scoped>
.party-work {
  .box {
    .content-template {
      span {
        &:nth-child(1) {
          color: #e4080d;
        }
      }
      padding: 0.2rem;
    }
    .title {
      img {
        width: 0.48rem;
        height: 0.48rem;
        border-radius: 50%;
        margin: 0.2rem;
      }
      display: flex;
      align-items: center;
      line-height: 3;
    }
    width: 94%;
    margin: 0 auto;
    background: #fff;
    border-radius: 0.08rem;
    font-size: 0.3rem;
  }
}
</style>